module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.sellpoint) ? _c('div', {
    staticStyle: {
      "text-align": "left",
      "padding": "1em",
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "menu-links-strip menu-links-strip-2"
  }, [_c('ul', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('product', 'setBusinessCategoryProductDetails', _vm.sellpoint, '/account/business/product')
      }
    }
  }, [_c('li', [_vm._v("\n            Product Details\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('product', 'setBusinessCategoryProductItems', _vm.sellpoint, '/account/business/product/types')
      }
    }
  }, [_c('li', [_vm._v("\n            Product Types / Variations\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('product', 'setBusinessCategoryProductReviews', _vm.sellpoint, '/account/business/product/reviews')
      }
    }
  }, [_c('li', [_vm._v("\n            Reviews\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('product', 'setBusinessCategoryProductOrders', _vm.sellpoint, '/account/business/product/orders')
      }
    }
  }, [_c('li', [_vm._v("\n            Orders\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('product', 'setBusinessCategoryProductAddOns', _vm.sellpoint, '/account/business/product/addons')
      }
    }
  }, [_c('li', [_vm._v("\n            Product Addons\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('product', 'setBusinessCategoryProductDiscountCoupons', _vm.sellpoint, '/account/business/product/discounts')
      }
    }
  }, [_c('li', [_vm._v("\n            Discounts and Coupons\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('product', 'setBusinessCategoryProductShippingInformation', _vm.sellpoint, '/account/business/product/shipping')
      }
    }
  }, [_c('li', [_vm._v("\n            Shipping and Delivery \n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat component-tabs"
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-baa7fccc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Account/Sellpoint/Product/ProductSettings.vue
// module id = 583
// module chunks = 0